/** Phase: GroupCreate form — ko/en/vi/ru */

const createForm = {
  title: ['모임 만들기', 'Create group', 'Tạo nhóm', 'Создать группу'],
  stepBasic: ['기본 정보', 'Basic info', 'Thông tin cơ bản', 'Основное'],
  stepRegion: ['지역 · 언어 · 태그', 'Region · language · tags', 'Khu vực · ngôn ngữ · thẻ', 'Регион · язык · теги'],
  stepSettings: ['모임 설정', 'Group settings', 'Cài đặt nhóm', 'Настройки группы'],
  nameLabel: ['모임 이름 *', 'Group name *', 'Tên nhóm *', 'Название группы *'],
  typeLabel: ['타입', 'Type', 'Loại', 'Тип'],
  privacyLabel: ['공개 설정', 'Visibility', 'Quyền riêng tư', 'Видимость'],
  coverUrlLabel: ['커버 이미지 URL', 'Cover image URL', 'URL ảnh bìa', 'URL обложки'],
  coverUrlPlaceholder: ['https://...', 'https://...', 'https://...', 'https://...'],
  coverPhotoLabel: ['커버 사진', 'Cover photo', 'Ảnh bìa', 'Фото обложки'],
  coverPhotoPick: ['사진 선택', 'Choose photo', 'Chọn ảnh', 'Выбрать фото'],
  coverPhotoUploading: ['업로드 중…', 'Uploading…', 'Đang tải lên…', 'Загрузка…'],
  coverPhotoUploadFailed: [
    '사진 업로드에 실패했습니다.',
    'Could not upload photo.',
    'Không tải được ảnh.',
    'Не удалось загрузить фото.',
  ],
  coverPhotoRemove: ['사진 제거', 'Remove photo', 'Xóa ảnh', 'Удалить фото'],
  descriptionLabel: ['소개', 'Description', 'Mô tả', 'Описание'],
  regionLabel: ['지역', 'Region', 'Khu vực', 'Регион'],
  primaryLanguageLabel: ['주 사용 언어', 'Primary language', 'Ngôn ngữ chính', 'Основной язык'],
  multiLanguageLabel: ['다국어 모임', 'Multilingual group', 'Nhóm đa ngôn ngữ', 'Многоязычная группа'],
  tagsLabel: ['태그 (쉼표로 구분)', 'Tags (comma-separated)', 'Thẻ (phân cách bằng dấu phẩy)', 'Теги (через запятую)'],
  tagsPlaceholder: ['러닝, 새벽, 다낭', 'running, morning, Da Nang', 'chạy, sáng, Đà Nẵng', 'бег, утро, Дананг'],
  maxMembersLabel: ['최대 인원', 'Max members', 'Số tối đa', 'Макс. участников'],
  addChannel: ['+ 메신저 추가', '+ Add messenger', '+ Thêm kênh', '+ Добавить мессенджер'],
  removeChannel: ['삭제', 'Remove', 'Xóa', 'Удалить'],
  memberLimitLabel: ['모임 인원', 'Group size', 'Số thành viên', 'Размер группы'],
  memberLimitUnlimited: ['무제한', 'No limit', 'Không giới hạn', 'Без лимита'],
  memberLimitSmall: ['소모임 (2~10명)', 'Small (2–10)', 'Nhỏ (2–10)', 'Малая (2–10)'],
  memberLimitMedium: ['중모임 (5~30명)', 'Medium (5–30)', 'Vừa (5–30)', 'Средняя (5–30)'],
  memberLimitLarge: ['대모임 (10~100명)', 'Large (10–100)', 'Lớn (10–100)', 'Большая (10–100)'],
  memberLimitCustom: ['직접 설정', 'Custom', 'Tùy chỉnh', 'Свой диапазон'],
  memberMinLabel: ['최소', 'Min', 'Tối thiểu', 'Мин.'],
  memberMaxLabel: ['최대', 'Max', 'Tối đa', 'Макс.'],
  memberLimitRangeSep: ['~', '~', '~', '~'],
  toastMemberRangeInvalid: [
    '인원은 최소 2명 이상, 최대는 최소 이상·직접 설정 시 10,000명 이하로 입력해 주세요.',
    'Enter min 2+, max ≥ min, and max up to 10,000 for custom.',
    'Nhập tối thiểu ≥2, tối đa ≥ tối thiểu (tối đa 10.000 khi tùy chỉnh).',
    'Мин. от 2, макс. ≥ мин. (до 10 000 при своём диапазоне).',
  ],
  requiresApprovalLabel: ['가입 승인 필요', 'Require approval to join', 'Cần duyệt khi tham gia', 'Требуется одобрение'],
  rulesLabel: ['모임 규칙 (한 줄에 하나)', 'Group rules (one per line)', 'Quy tắc (mỗi dòng một quy tắc)', 'Правила (по одному в строке)'],
  contactSection: ['연락 채널 (선택)', 'Contact channels (optional)', 'Kênh liên hệ (tùy chọn)', 'Каналы связи (необязательно)'],
  contactHint: [
    '멤버가 "연락하기" 버튼으로 이 채널에 연결됩니다.',
    'Members can reach you through these channels via the "Contact" button.',
    'Thành viên sẽ liên hệ qua các kênh này bằng nút "Liên hệ".',
    'Участники смогут связаться через эти каналы кнопкой «Связаться».',
  ],
  contactKakaoPlaceholder: [
    '카카오 오픈채팅 ID 또는 링크',
    'Kakao open-chat ID or link',
    'ID hoặc liên kết Kakao open-chat',
    'ID или ссылка Kakao open-chat',
  ],
  contactWhatsappPlaceholder: [
    '국가코드 포함 WhatsApp 번호',
    'WhatsApp number with country code',
    'Số WhatsApp kèm mã quốc gia',
    'Номер WhatsApp с кодом страны',
  ],
  contactZaloPlaceholder: [
    'Zalo 번호 또는 링크',
    'Zalo number or link',
    'Số hoặc liên kết Zalo',
    'Номер или ссылка Zalo',
  ],
  next: ['다음', 'Next', 'Tiếp', 'Далее'],
  prev: ['이전', 'Back', 'Quay lại', 'Назад'],
  submit: ['모임 만들기', 'Create group', 'Tạo nhóm', 'Создать группу'],
  submitting: ['생성 중…', 'Creating…', 'Đang tạo…', 'Создание…'],
  toastLoginRequired: [
    '로그인 후 모임을 만들 수 있습니다.',
    'Sign in to create a group.',
    'Đăng nhập để tạo nhóm.',
    'Войдите, чтобы создать группу.',
  ],
  toastNameRequired: [
    '모임 이름을 입력해 주세요.',
    'Enter a group name.',
    'Nhập tên nhóm.',
    'Введите название группы.',
  ],
  toastCreated: ['모임이 생성되었습니다.', 'Group created.', 'Đã tạo nhóm.', 'Группа создана.'],
  toastCreateFailed: [
    '모임 생성에 실패했습니다.',
    'Could not create group.',
    'Không tạo được nhóm.',
    'Не удалось создать группу.',
  ],
  langKo: ['한국어', 'Korean', 'Tiếng Hàn', 'Корейский'],
  langEn: ['English', 'English', 'Tiếng Anh', 'Английский'],
  langVi: ['Tiếng Việt', 'Vietnamese', 'Tiếng Việt', 'Вьетнамский'],
  langRu: ['Русский', 'Russian', 'Tiếng Nga', 'Русский'],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return {
    groups: {
      createForm: pick(createForm, langIndex),
    },
  };
}

export const phaseGroupsCreateKo = buildLang(0);
export const phaseGroupsCreateEn = buildLang(1);
export const phaseGroupsCreateVi = buildLang(2);
export const phaseGroupsCreateRu = buildLang(3);

/** Single-select language options for GroupCreate (ko/en/vi/ru i18n bundle). */
export const GROUP_CREATE_LANGUAGE_OPTIONS = [
  { code: 'ko', labelKey: 'groups.createForm.langKo' },
  { code: 'en', labelKey: 'groups.createForm.langEn' },
  { code: 'vi', labelKey: 'groups.createForm.langVi' },
  { code: 'ru', labelKey: 'groups.createForm.langRu' },
];
